import React from 'react'
import { GetTagInstructionsContainer, CodeBlock } from '../../Instructions.styled'
import { useTranslation } from 'react-i18next'
import * as codeFunctions from '../../utils'
import { CopyTextButton } from '@clickcease/cc-client-components-lib'
import {
  CodeBlockWrapper,
  GoogleTagManagerManualText,
  InstructionsTitle,
} from './GoogleTagManagerManual.styled'
import { BulletLine } from '../BulletLine'

export const GoogleTagManagerManualMethod = ({
  tagUrl,
  domainHashCode,
}: {
  tagUrl: string
  domainHashCode: string
  noMargin?: boolean
}) => {
  const { t } = useTranslation('domainManagement')

  const code = codeFunctions.generateCodeScript(tagUrl, domainHashCode)
  const noScriptUrl = codeFunctions.generateGtmNoScriptUrl(tagUrl, domainHashCode)

  return (
    <GetTagInstructionsContainer>
      <GoogleTagManagerManualText css={{ marginBottom: '$4' }}>
        {t('get_tag_modal.gtm_manual_steps.option_2')}
      </GoogleTagManagerManualText>
      <GoogleTagManagerManualText>
        {t('get_tag_modal.gtm_manual_steps.title')}
      </GoogleTagManagerManualText>
      <BulletLine>1. {t('get_tag_modal.gtm_manual_steps.step_1')}</BulletLine>
      <BulletLine>2. {t('get_tag_modal.gtm_manual_steps.step_2')}</BulletLine>
      <BulletLine>3. {t('get_tag_modal.gtm_manual_steps.step_3')}</BulletLine>
      <BulletLine>4. {t('get_tag_modal.gtm_manual_steps.step_4')}</BulletLine>
      <BulletLine>5. {t('get_tag_modal.gtm_manual_steps.step_5')}</BulletLine>
      <BulletLine>6. {t('get_tag_modal.gtm_manual_steps.step_6')}</BulletLine>

      {/* Code blocks */}
      <CodeBlockWrapper>
        <InstructionsTitle>{t('get_tag_modal.gtm_manual_steps.invocation_tag')}</InstructionsTitle>
        <CodeBlock>{code}</CodeBlock>
        <CopyTextButton value={code} buttonText={t('get_tag_modal.copy-code')} />
      </CodeBlockWrapper>
      <CodeBlockWrapper>
        <InstructionsTitle>{t('get_tag_modal.gtm_manual_steps.no_script_tag')}</InstructionsTitle>
        <CodeBlock>{noScriptUrl}</CodeBlock>
        <CopyTextButton value={noScriptUrl} buttonText={t('get_tag_modal.copy-code')} />
      </CodeBlockWrapper>
    </GetTagInstructionsContainer>
  )
}
